export const ACTIONS = {
  SET_MILESTONE_EDIT_ENABLED: 'SET_MILESTONE_EDIT_ENABLED',
  CLEAR_MILESTONE_EDIT_ENABLED: 'CLEAR_MILESTONE_EDIT_ENABLED',
};

export const setMilestoneEditEnabled = (payload: string | null) => ({
  type: ACTIONS.SET_MILESTONE_EDIT_ENABLED,
  payload,
});

export const clearMilestoneEditEnabled = () => ({
  type: ACTIONS.CLEAR_MILESTONE_EDIT_ENABLED,
});
